import React from 'react';
import { FaLeaf, FaSeedling, FaBan } from 'react-icons/fa';
import './HomeInfo.css';

import imgCampo from '../assets/home_info1.jpg';
import imgVaca from '../assets/home_info2.jpg';
const HomeInfo = () => {
  return (
    <div className="home-info-container">
      
      {/* BLOQUE 1: UBICACIÓN (Texto Izquierda, Imagen Derecha) */}
      <section className="info-block">
        <div className="info-text">
          <h2>De dónde somos</h2>
          <div className="title-underline"></div>
          <p>
            Nos encontramos en el corazón productivo de <strong>Cinco Saltos, Río Negro</strong>. 
            Nuestra ubicación privilegiada en la Patagonia nos brinda el clima y la tierra ideal 
            para desarrollar una actividad tambera de excelencia.
          </p>
          <p>
            Acá, entre las chacras y el aire puro del sur, trabajamos todos los días 
            para llevar el verdadero sabor del campo directamente a tu mesa, respetando 
            los tiempos de la naturaleza y la tradición quesera.
          </p>
        </div>
        <div className="info-image">
          {/* Reemplazar con la foto real del mapa o del campo */}
          <img 
            src={imgCampo} 
            alt="Ubicación en Cinco Saltos" 
            loading="lazy"
          />
        </div>
      </section>

      {/* BLOQUE 2: VALORES (Imagen Izquierda, Texto Derecha) */}
      {/* Agregamos la clase "reverse" para dar vuelta las columnas en PC */}
      <section className="info-block reverse">
        <div className="info-image">
          <img 
            src={imgVaca} 
            alt="Vacas pastando alfalfa" 
            loading="lazy"
          />
        </div>
        <div className="info-text">
          <h2>Por qué elegirnos</h2>
          <div className="title-underline"></div>
          <p className="valores-intro">
            Creemos que un gran queso nace mucho antes de llegar a la sala de elaboración. 
            Nace en la tierra, en el cuidado de nuestros animales y en nuestra filosofía de trabajo.
          </p>
          
          <ul className="valores-lista">
            <li>
              <FaLeaf className="valor-icon" />
              <div>
                <strong>Producción Agroecológica</strong>
                <span>Trabajamos en armonía con el medio ambiente, respetando los ciclos naturales del suelo.</span>
              </div>
            </li>
            <li>
              <FaSeedling className="valor-icon" />
              <div>
                <strong>Alimentación Propia</strong>
                <span>Nuestras vacas se alimentan con alfalfa cultivada y cosechada por nosotros mismos, garantizando su nutrición.</span>
              </div>
            </li>
            <li>
              <FaBan className="valor-icon" />
              <div>
                <strong>Sin Aditivos</strong>
                <span>Elaboramos quesos genuinos, libres de conservantes y aditivos artificiales. 100% naturales.</span>
              </div>
            </li>
          </ul>
        </div>
      </section>

    </div>
  );
};

export default HomeInfo;